import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { ShoppingCartItemsInterface } from '@interfaces/shopping-cart/shopping-cart-items-interface';
import { MenuActions } from '../../../states/menu_actions';
import { DecimalPipe, NgClass } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-purchase-completion-item-card',
  imports: [LnImageFrameComponent, NgClass, TranslocoPipe, DecimalPipe],
  templateUrl: './purchase-completion-item-card.component.html',
  styleUrl: './purchase-completion-item-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchaseCompletionItemCardComponent {
  @Input({ required: true }) product!: ShoppingCartItemsInterface;
  private menuActions = inject(MenuActions);
  get singlePiece(): boolean {
    return this.product.producto.productoPrincipal.isPiezaUnica;
  }
  navigateToShoppingCart(): void {
    this.menuActions.navigateToShoppingCart();
  }
  navigateToProductDetails() {
    this.menuActions.navigateToProductDetails(
      this.product.producto.productoPrincipal.vendedorId,
      this.product.producto.productoPrincipal.id,
      this.product.producto.id
    );
  }
}
